import { Plugin, H5Player } from '@tencent/thumbplayer-h5';
import { __extends, __assign, __spreadArray } from 'tslib';
import { txpHideClass, isMobile } from '@tencent/thumbplayer-plugin-utils';

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = "@-webkit-keyframes txp_overlay_play{0%{-webkit-transform:scale(.5);transform:scale(.5);opacity:1}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}@keyframes txp_overlay_play{0%{-webkit-transform:scale(.5);transform:scale(.5);opacity:1}to{-webkit-transform:scale(1);transform:scale(1);opacity:0}}.txp_contextmenu{background:rgba(30,30,32,.9);position:fixed;width:234px;z-index:9999;padding:10px 0;color:#bbb;overflow:hidden;font-size:12px}.txp_contextmenu.txp_none,.txp_contextmenu .txp_none{display:none}.txp_contextmenu .txp_clipboard{top:0;left:100%;position:absolute;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.txp_contextmenu .txp_menuitem{padding-left:20px;height:34px;line-height:34px;cursor:pointer;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.txp_contextmenu .txp_menuitem:hover{background-color:#26262b}.txp_overlay_link{position:absolute;left:0;top:0;width:100%;height:100%;z-index:5;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;visibility:hidden;font-size:14px}.txp_overlay_link.txp_show{display:-webkit-box;display:-ms-flexbox;display:flex;visibility:visible;-webkit-animation:txp_overlay_play 1s ease-out both;animation:txp_overlay_play 1s ease-out both;pointer-events:none}.txp_overlay_link .txp_icon_link{background:rgba(30,30,32,.9);width:60px;height:60px;border-radius:30px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.txp_overlay_link .txp_icon_link .txp_icon{position:relative;width:36px;height:36px;fill:#fff}";
styleInject(css_248z);

var UIContextMenuPluginName = 'context-menu';

var UIContextMenuPlugin = /** @class */ (function (_super) {
    __extends(UIContextMenuPlugin, _super);
    function UIContextMenuPlugin(player, config, extra) {
        var _this = _super.call(this, player, config, extra) || this;
        _this.menuConfig = [];
        _this.show = function () {
            _this.$el.classList.remove(txpHideClass);
        };
        _this.hide = function () {
            _this.$el.classList.add(txpHideClass);
        };
        _this.config = _this.mergeConfig(config);
        _this.start(_this.config.menus, { hideVInfo: _this.config.hideVInfo });
        return _this;
    }
    /** 动态设置右键菜单，覆盖原有设置 */
    UIContextMenuPlugin.prototype.start = function (items, param) {
        if (!items || items.length <= 0)
            return;
        if ((param === null || param === void 0 ? void 0 : param.hideVInfo) !== true)
            items.unshift({ role: 'openvinfo', label: '视频信息' });
        this.menuConfig = items;
        if (this.$el) {
            this.$el.innerHTML = "\n      " + items.map(function (v) { return "<div class=\"txp_menuitem\" data-role=\"" + (v.role || '') + "\">" + v.label + "</div>"; }).join('') + "\n      <textarea class=\"txp_clipboard\" style=\"position: absolute; left: 100%; top: 0;\"></textarea>\n      ";
            return;
        }
        var htmlStr = "\n    <div class=\"txp_contextmenu " + txpHideClass + "\" style=\"overflow:hidden\">\n      " + items.map(function (v) { return "<div class=\"txp_menuitem\" data-role=\"" + (v.role || '') + "\">" + v.label + "</div>"; }).join('') + "\n      <textarea class=\"txp_clipboard\" style=\"position: absolute; left: 100%; top: 0;\"></textarea>\n    </div>\n    <div class=\"txp_overlay_link " + txpHideClass + "\">\n        <div class=\"txp_icon_link\">\n            <svg class=\"txp_icon\" viewBox=\"0 0 36 36\" >\n              <path d=\"M26.5 26h-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5c2.5 0 4.5-2 4.5-4.5S29 14 26.5 14h-5c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h5c4.1 0 7.5 3.4 7.5 7.5S30.6 26 26.5 26zM12 18.5c0-.8.7-1.5 1.5-1.5h9c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-9c-.8 0-1.5-.7-1.5-1.5zm2.5-4.5h-5C7 14 5 16 5 18.5S7 23 9.5 23h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5h-5C5.4 26 2 22.6 2 18.5S5.4 11 9.5 11h5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z\"></path>\n            </svg>\n        </div>\n    </div>\n    ";
        var container = this.player.container;
        container.insertAdjacentHTML('beforeend', htmlStr);
        this.$el = container.querySelector('.txp_contextmenu');
        this.$link = container.querySelector('.txp_overlay_link');
        this.bindDOMEvent();
    };
    UIContextMenuPlugin.prototype.showSuccess = function () {
        var _a, _b;
        // 移动端不展示这个动画
        if (isMobile)
            return;
        if (((_a = this.config) === null || _a === void 0 ? void 0 : _a.disableSuccessTip) || ((_b = this.config) === null || _b === void 0 ? void 0 : _b.disableSuccussTip))
            return;
        var $suc = this.$link;
        /** 用于动画展示的类名 */
        var animationClass = 'txp_show';
        $suc.classList.remove(txpHideClass);
        $suc.classList.add(animationClass);
        clearTimeout(this.sucTid);
        this.sucTid = setTimeout(function () {
            $suc.classList.add(txpHideClass);
            $suc.classList.remove(animationClass);
        }, 1e3);
    };
    UIContextMenuPlugin.prototype.destroy = function () {
        var removeDOM = function (dom) { return (dom === null || dom === void 0 ? void 0 : dom.parentNode) && dom.remove(); };
        [this.$el, this.$link].forEach(removeDOM);
        _super.prototype.destroy.call(this);
    };
    UIContextMenuPlugin.prototype.mergeConfig = function (config) {
        var contextMenuConfig = this.player.config.contextMenuConfig;
        return __assign(__assign(__assign({}, contextMenuConfig), config), { menus: __spreadArray(__spreadArray([], ((contextMenuConfig === null || contextMenuConfig === void 0 ? void 0 : contextMenuConfig.menus) || []), true), ((config === null || config === void 0 ? void 0 : config.menus) || []), true) });
    };
    UIContextMenuPlugin.prototype.bindDOMEvent = function () {
        var _this = this;
        var container = this.player.container;
        container.addEventListener('contextmenu', function (evt) {
            // 播放广告时不出右键菜单
            if (_this.player.isPlayingAd)
                return;
            // 先展示出来才能获取宽高
            _this.show();
            var _a = _this.player.container.getBoundingClientRect(), left = _a.left, top = _a.top, playerWidth = _a.width, playerHeight = _a.height;
            var clientX = evt.clientX, clientY = evt.clientY;
            var _b = _this.$el, width = _b.clientWidth, height = _b.clientHeight;
            var minLeftPos = playerWidth + left - width;
            var minTopPos = playerHeight + top - height;
            var leftPos = Math.min(minLeftPos, clientX);
            var topPos = Math.min(minTopPos, clientY);
            _this.$el.style.left = leftPos + "px";
            _this.$el.style.top = topPos + "px";
            evt.preventDefault();
        });
        container.addEventListener('click', this.hide);
        this.$el.addEventListener('click', function (evt) {
            var _a, _b;
            var target = evt.target;
            _this.showSuccess();
            var menuConf = (_a = _this.menuConfig) === null || _a === void 0 ? void 0 : _a.find(function (menu) { return menu.role === target.dataset.role; });
            if (typeof (menuConf === null || menuConf === void 0 ? void 0 : menuConf.callback) === 'function') {
                menuConf.callback(_this);
            }
            if (target.dataset.role === 'openvinfo') {
                (_b = _this.player.plugins['info-panel']) === null || _b === void 0 ? void 0 : _b.trigger();
            }
            _this.emit('clickContextMenu', target.dataset);
        });
    };
    UIContextMenuPlugin.pluginName = UIContextMenuPluginName;
    return UIContextMenuPlugin;
}(Plugin));

H5Player.registerPlugin(UIContextMenuPlugin.pluginName, UIContextMenuPlugin);

export { UIContextMenuPlugin };
